import { render, staticRenderFns } from "./SampleDetails.vue?vue&type=template&id=1db1c861&"
import script from "./SampleDetails.vue?vue&type=script&lang=js&"
export * from "./SampleDetails.vue?vue&type=script&lang=js&"
import style0 from "./SampleDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
